import { ActionTypes } from "../constants";

export default function shoppingGoals(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_SHOPPING_GOALS:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}